import { unref } from 'vue';
import { helpers } from '@vuelidate/validators';
import dayjs from 'dayjs';

export const endAfterStart = (startVal, message = 'End date must be after start date') =>
    helpers.withMessage(
        message,
        value => {
            let start = unref(startVal);
            if (!value || !start) return true;
            return !dayjs(value).isBefore(dayjs(start))
        }
    )